enum PosicaoDadosFranquia {
    Direita = 0,
    Centro = 1,
    Esquerda = 2,
}

export default PosicaoDadosFranquia;